import { Button } from '@seen/ui'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'
import type { JSX } from 'react'
import type { SDRDisplayStep } from '#src/components/sdr/display/utils.ts'

type Props = {
  selectedStep: SDRDisplayStep
  setSelectedStep: (step: SDRDisplayStep) => void
}

export function SDRDisplayForwardBackButtons({
  selectedStep,
  setSelectedStep,
}: Props): JSX.Element {
  return (
    <div className="flex grow flex-row items-center justify-end gap-2">
      {selectedStep === 1 ? null : (
        <Button
          onClick={() => setSelectedStep((selectedStep - 1) as SDRDisplayStep)}
        >
          <IconArrowLeft className="size-4" />
          Back
        </Button>
      )}
      {selectedStep === 4 ? null : (
        <Button
          onClick={() => setSelectedStep((selectedStep + 1) as SDRDisplayStep)}
        >
          Forward
          <IconArrowRight className="size-4" />
        </Button>
      )}
    </div>
  )
}
